import React from 'react'
import { BadgeText } from './BadgeText'

type DaysDisengagedIconProps = {
  days: number
  color: string
  width?: number | string
  height?: number | string
  className?: string
}

const SINGLE_DIGIT_BADGE_WIDTH = 14
const MULTI_DIGIT_BADGE_WIDTH = 17
const MAX_DISPLAYED_DAYS = 99

export const DaysDisengagedIcon = ({ days, color, width = 20, height = 20, className }: DaysDisengagedIconProps) => {
  const label = days > MAX_DISPLAYED_DAYS ? `${MAX_DISPLAYED_DAYS}+` : String(days)
  const badgeWidth = label.length > 1 ? MULTI_DIGIT_BADGE_WIDTH : SINGLE_DIGIT_BADGE_WIDTH

  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M25.1663 14.7969L16.2658 7.63021L11.8486 11.3166L6.83301 6.79688M25.1663 9.79687V14.7969L20.1663 14.7969"
        stroke="white"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="6" y="12" width={badgeWidth} height="14" rx="7" fill="white" />
      <BadgeText x={6 + badgeWidth / 2} y="19" fontSize={label.length > 2 ? 9 : 12} fill={color}>
        {label}
      </BadgeText>
    </svg>
  )
}
